export default __webpack_public_path__ + "static/media/Bandit's Leggings of the Howling Wind.3dc7abf2.jpg";